import { ProtectedRouter } from 'infrastructure/routing';
import { Route, Routes } from 'react-router-dom';
import { PERFORMANCE_MEASUREMENT_GET } from 'domain/shared/performanceMeasurement';
import PerformanceMeasurementContext from 'domain/people/employee/performanceMeasurement/PerformanceMeasurementContext';
import { createRoute } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import PerformanceMeasurementPageLayout from './List/index';

export const MEASUREMENT_PATH = '/measurement';

const PerformanceMeasurementRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = createRoute({ listRoute: MEASUREMENT_PATH });

  return (
    <ProtectedRouter basePath={MEASUREMENT_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <PerformanceMeasurementContext permissionToCheck={PERFORMANCE_MEASUREMENT_GET}>
              <PerformanceMeasurementPageLayout />
            </PerformanceMeasurementContext>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PerformanceMeasurementRouter.getRouterPath = () => `${MEASUREMENT_PATH}/*`;

export default PerformanceMeasurementRouter;
